<div class="mobile-header">
  <div class="header-content">
    <!-- Logo (Left) -->
    <a [routerLink]="['/']" class="logo" aria-label="Homepage">
      <app-logo></app-logo>
    </a>

    <!-- Right side controls -->
    <div class="right-controls">
      <!-- Locale Button -->
      <div class="locale-wrapper">
        <app-locale-button></app-locale-button>
      </div>

      <!-- Hamburger Menu Icon -->
      <button 
        class="menu-button" 
        (click)="onMenuClick()"
        *ngIf="showMenuIcon"
        aria-label="Open menu">
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="0" y1="2" x2="20" y2="2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <line x1="0" y1="8" x2="20" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <line x1="0" y1="14" x2="20" y2="14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  </div>
</div>
